<template>
  <div class="py-2">
    <el-row :gutter="24" v-if="cards">
      <el-col :xs="12" :sm="12" class="pt-1">
        <span class="font-weight-bold"> Price Breakdown </span>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="$breakpoint.mdAndDown ? 24 : 12">
        <div
          v-for="(rule, ruleIdx) in filterPricingRulesForOrderReceipt(
            order,
            getOrderMarketWindow,
            productConfig,
            'MARKET_DATA'
          )"
          :key="`${index}_rule${ruleIdx}`"
          class="d-flex justify-content-between"
        >
          <el-col :xs="12" :sm="12" class="pt-1">
            <span :class="!cards ? 'font-weight-bold' : 'font-weight-medium'">{{ getPricingRuleName(rule, bioProductConfig) }}</span>
          </el-col>
          <el-col :xs="12" :sm="12" class="pt-1">
            <span>{{ displayRuleValueWithUnit(order, rule.action) }}</span>
          </el-col>
        </div>
      </el-col>
      <el-col :span="$breakpoint.mdAndDown ? 24 : 12">
        <div
          v-for="(rule, ruleIdx) in getProductPriceRules(order)"
          :key="`rule${ruleIdx}`"
          class="d-flex justify-content-between"
        >
          <el-col :xs="12" :sm="12" class="pt-1" v-if="fieldRelevantForDisplay(rule.name)">
            <span :class="!cards ? 'font-weight-bold' : 'font-weight-medium'">{{ rule.name }}</span>
          </el-col>
          <el-col :xs="12" :sm="12" class="pt-1" v-if="fieldRelevantForDisplay(rule.name)">
            <span>{{ rule.value }}
              <span v-if="rule.name === 'Customer Margin' && order.pricingEngineEnabled"> ppl</span>
            </span>
          </el-col>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { filterPricingRulesForOrderReceipt } from "@/util/orderBuilder";
import {
  getPricingRuleName,
  getPricingRuleValueWithUnit,
  convertCelsiusRuleToPpl,
  simpleCalculateCostAdditionPpl,
} from "@/util/pricingRules";
import { rulesEnum } from "@/util/enums/rules";
import breakpoint from "@/mixins/index";
export default {
  props: {
    index: {
      type: Number,
      required: true,
      default: 0,
    },
    order: {
      type: Object,
      required: true,
      default: () => {},
    },
    getOrderMarketWindow: {
      type: Object,
      required: true,
      default: () => {},
    },
    productConfig: {
      type: Object,
      required: true,
      default: () => {},
    },
    bioProductConfig: {
      type: Array,
      required: true,
      default: [],
    },
    cards: {
      type: Boolean,
      required: false,
      default: false,
    },
    isContract: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      filterPricingRulesForOrderReceipt,
      getPricingRuleName,
      getPricingRuleValueWithUnit,
    };
  },
  mixins: [breakpoint],
  created() {},
  computed: {},
  watch: {},
  methods: {
    fieldRelevantForDisplay(value) {
      if (value === 'Customer Margin' && this.isContract) {
        return false
      } else {
        return true
      }
    },
    displayRuleValueWithUnit: function (order, ruleAction) {
      const { product_id, pricingAuditTrail } = order;
      const { unitOfMeasurement, value } = ruleAction;

      let ruleActionToDisplay = ruleAction;

      // If rule is set in celsius, convert into ppl first before displaying. Otherwise we can display the rule straightaway
      if (unitOfMeasurement === rulesEnum.eUnitType.Celsius.id) {
        const convertedRuleValue = convertCelsiusRuleToPpl(
          product_id,
          pricingAuditTrail,
          value,
          this.getOrderMarketWindow
        );
        const convertedRuleAction = {
          ...ruleAction,
          value: convertedRuleValue,
          unitOfMeasurement: rulesEnum.eUnitType.PencePerLitre.id,
        };
        ruleActionToDisplay = convertedRuleAction;
      }

      return getPricingRuleValueWithUnit(ruleActionToDisplay);
    },
    containsTargetType(target, targets) {
      const targetIndex = targets.findIndex(({ type }) => type === target);
      return targetIndex !== -1;
    },
    getProductPriceRules(order) {
      const TARGET_ACCOUNT_ENUM = rulesEnum.eTargetType.Account;

      const productRules = filterPricingRulesForOrderReceipt(
        order,
        this.getOrderMarketWindow,
        this.productConfig,
        "PRODUCT_SPECIFIC"
      );
      const filteredProductRules = productRules.filter(
        ({ targets }) => !this.containsTargetType(TARGET_ACCOUNT_ENUM, targets)
      );
      const formattedProductRules = filteredProductRules.map((rule) => {
        const name = getPricingRuleName(rule, this.bioProductConfig);
        const value = this.displayRuleValueWithUnit(order, rule.action);
        return { name, value };
      });

      const { pricingAuditTrail } = order;
      const accountMarginRules = productRules.filter(({ targets }) =>
        this.containsTargetType(TARGET_ACCOUNT_ENUM, targets)
      );

      const customerMarginValue = accountMarginRules
        .reduce(
          (acc, rule) => {
            return (
              acc + simpleCalculateCostAdditionPpl(rule, order.product_id, this.getOrderMarketWindow, pricingAuditTrail)
            );
          },
          order.adjustment ? order.adjustment : 0
        )
        .toFixed(2);

      const customerMargin = { name: "Customer Margin", value: customerMarginValue };
      formattedProductRules.push(customerMargin);

      return formattedProductRules;
    },
  },
};
</script>

<style lang="scss">
</style>
